export default __webpack_public_path__ + "static/media/Page10.629a256e.txt";